// extracted by mini-css-extract-plugin
export default {"btn":"InlineTip_btn__7MG0e","btnOverlay":"InlineTip_btnOverlay__ZSVwD","tip":"InlineTip_tip__m1p9D"};